import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Container, Header } from 'semantic-ui-react';
import { withPageViewTracking } from '../analytics';
import { Wrappers } from '../components';

/*eslint-disable*/
const Terms = () => (
  <Wrappers.Layout menu>
    <Container as="main" text>
      <Header as="h1">
        <FormattedMessage
          id="title.terms"
          description="Terms and Conditions page title"
          defaultMessage="Terms and Conditions"
        />
      </Header>
      <h3 className="text--upper">
        If you continue to browse and use this website you are agreeing to
        comply with and be bound by the following terms and conditions, which,
        together with our privacy policy, govern Ag Growth International Inc.
        and is affiliates and subsidiaries and entities (collectively, “AGI”).
        AGI may, in its sole discretion, revise these Terms at any time without
        advance notice to you. You are bound by such revisions by your continued
        use or visitation of the Website.
      </h3>
      <p>
        The use of “us”, “we”, Ag Growth International Inc., or its affiliates,
        entities or divisions, including but not limited to: Westfield
        Industries, Westfield, Wheatheart Manufacturing, Wheatheart, Batco
        Manufacturing, Batco, Batco-Rem, Rem, AGI Nobleford, Twister, Grain
        Guard, Keho, AGI Saskatoon, Hi Roller, Union Iron, Tramco, Airlanco,
        Tramco Europe, Euro Tramco, BV, refers to AGI. The term "you" refers to
        the user or viewer of the Website.
      </p>
      <p>
        AGI owns all intellectual property rights, including without limitation
        copyright and trade-mark rights, in all materials on or comprising the
        Website (“Content”), including, without limitation, all written, audio
        visual or other materials and graphical elements on the Website, but
        excluding User Content as defined below. Website Content may not be used
        by you without the express written permission of AGI, such use to be
        solely for non-commercial purposes.
      </p>
      <p>
        To access some features of the Website you may have to register for an
        AGI user account. When registering for your user account you must
        provide accurate and complete information (“User Content”). You are
        solely responsible for the activity that occurs on your User Account.
        You must notify AGI immediately of any breach of security or
        unauthorized use of your User Account. AGI will not be liable for your
        losses caused by any unauthorized use of your User Account, however, you
        may be liable for the losses of AGI or others due to such unauthorized
        use.
      </p>
      <p>
        The Website and Content is provided "as is" and without warranties or
        conditions of any kind, either expressed or implied, including any
        implied warranties of merchantability, merchantable quality, fitness for
        a particular purpose, title, or non-infringement. AGI does not warrant
        that the Website or Content contained in this Website will be
        uninterrupted or error-free, that defects will be corrected, or that
        this website or the server that makes it available are free of viruses
        or other harmful components.
      </p>
      <p>
        Without limiting the foregoing, AGI does not warrant or make any
        representation regarding use, the ability to use, or the result of use
        of the content in terms of accuracy, reliability, or otherwise. The
        content may include technical inaccuracies or typographical errors. AGI
        makes no warranties that your use of the content will not infringe the
        rights of others and assumes no liability or responsibility for errors
        or omissions in such content.
      </p>
      <p>
        You agree to defend, indemnify and hold harmless AGI, its employees,
        agents, officers and directors from and against any and all claims,
        damages, obligations, judgments, losses, liabilities, costs or debt,
        attorney's fees and other expenses arising from: (i) your use of and
        access to the Website; (ii) your violation of any third party right,
        including without limitation any copyright, property, or privacy right;
        or (iii) any claim that you did not have the right to provide any user
        content or that your user content caused damage to a third party. This
        defense and indemnification obligation will survive these terms and your
        use of the Website.
      </p>
      <p>
        You may not use the Website for any illegal or unauthorized purpose.
        Your use of the Website shall be governed under the laws of Canada, as
        well as any applicable Provincial, State, Federal or local law.
      </p>
    </Container>
  </Wrappers.Layout>
);

export default withPageViewTracking()(Terms);
